import React from "react";

export default function GameSummary(props) {
  const { content_new, isDetail } = props;

  return (
    <div>
      <div style={{ maxHeight: isDetail ? 'normal' : "60vh", overflow: "scroll" ,paddingTop: isDetail ? 10 : 0}}>
        {(isDetail ? content_new : content_new.slice(0, 4)).map(
          (item, index) => (
            <div
              className="list-item"
              key={index}
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: 5,
              }}
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAACnklEQVR4AbSWv2tTcRTFkyelScAqLmZwSAbzy0E0Lu3SQhGFiuDQqaBUcRCapaWTdPQfkOrk7KKI6CaIcSi4ZOiSX4SQoWBBhTqUGE0TPyd+G15eXtK82IZ7uN/vvfeck7z3fY9YPo+fSCRyNhaL3VX2SPV5NgsGg9csy3qifOJm7Xb7MSYXTGY5enj6ZfF4/DbSc0AxZ/Zaj4SRzVKp1DkU14E91k3dXhu4Htms1Wrd8Pv9l+1K2qturw1bj2RmTt4iQqeBPbRfNH173XU9klkoFLoKex64xbzpu/V6am5m/mg0ej6RSMwmk8lH5KecvE1YU8AtptTXXPLf/Kz4DPpBT1gMTYNVTtYL8hb4Pjk5+ZWpLCLPyRlykjwwTF9zms+KLx2wZXRXWU/rl0VQyXCzH5BngE5d37ei7iXEl86M0c1AjljhcPgVizXwA5xESHdNPlY2m20Wi8U3uCyDb+A4Q3rL0pePLmNHnMJ7npl7bIrgOKIoPekeinXNVCiXyx8YWGG9C/4ndqUjPbtIjxmNAwY+clPvsN4B48SO+NKBfAC64TTrNAqFwhcWG2Cc2DD8Pq6rmaZ4ds4oe8Uw3kAzLsUVr0aaH8YbaAZxLLNhPFcz3uIBSENfUfQHRdLw+/quZoFA4BKTE8Ae3I72HpdJp3VFmcIeA21gjwnDt9c6a1cznhHnJdxH/DV/dO7X6/VbnLZnytqrjtI+6IYLv9NzNUPAbvaJyYVGo/EQk7e1Wu0Xe5+y9qqzXwCaI/l8Dr7v8ONmZjF8kYFtsMS3v8kr53O1Wv3J3nnJ2qqrrzn6S2Db8Pu0+wrpdPoU92Kz2WxeR+RlPp//jcCRoTnNiye+dJykPrNcLvenVCq9q1QqemM754/ciye+dJzDfwEAAP//dHGriAAAAAZJREFUAwBnJwtGUdrJ3wAAAABJRU5ErkJggg=="
                alt=""
                style={{
                  width: "9px",
                  verticalAlign: "middle",
                  marginRight: "5px",
                  position: "relative",
                  top: "-1px",
                }}
              />
              <div style={{ display: "inline-block", verticalAlign: "middle" }}>
                {item.title ? (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <div
                      style={{
                        fontSize: '0.28rem',
                        color: "#333",
                        fontWeight: 500,
                        zIndex: 2,
                        position: "relative",
                        paddingBottom: "2px",
                      }}
                    >
                      {item.title}
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        bottom: 6,
                        height: 6,
                        background:
                          "linear-gradient(to right , var(--MainColor) , transparent)",
                        zIndex: 1,
                        opacity: 0.35,
                      }}
                    ></div>
                  </div>
                ) : (
                  ""
                )}
                <div style={{ color: "#666", fontSize: '0.24rem' }}>
                  {item.content}
                </div>
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  );
}
